var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterIcon41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.649 0.617214C13.9754 0.99395 12.5844 1.66772 7.75204 4.48599C3.88327 6.73915 2.62265 7.70997 1.65184 9.18068C0.260816 11.2817 0 12.8104 0 18.9178C0 25.018 0.260816 26.6626 1.55765 28.6622C2.52847 30.1691 3.91225 31.2559 7.65786 33.4366C12.5771 36.2983 14.0334 37.0083 15.7214 37.3561C16.7937 37.5807 18.4745 37.5372 19.496 37.2619C20.9378 36.8707 22.3722 36.1607 26.27 33.9075C28.7333 32.4803 29.849 31.792 30.7908 31.0965C32.8411 29.5968 33.9641 27.8798 34.406 25.5904C34.6741 24.2211 34.7176 23.0257 34.6813 18.2658C34.6596 14.5202 34.6306 13.6508 34.5292 13.0132C34.08 10.2167 32.9063 8.36201 30.5155 6.6667C28.6029 5.31191 22.5461 1.87058 20.8508 1.17507C19.5902 0.653439 19.0179 0.537521 17.5689 0.508541C16.4821 0.486805 16.1634 0.501297 15.649 0.617214ZM18.8367 6.1016C20.4596 6.40589 22.0752 7.30425 23.1909 8.50691C26.0744 11.6295 26.0454 16.3459 23.1185 19.4105C21.0537 21.5695 18.076 22.3954 15.2288 21.5912C14.3159 21.3376 13.1205 20.7146 12.3598 20.0915C9.80959 18.0339 8.78082 14.5347 9.80959 11.4411C10.1936 10.2892 10.7514 9.3763 11.6208 8.46344C12.8162 7.21732 14.1276 6.47109 15.7359 6.13783C16.5908 5.9567 18.0036 5.94221 18.8367 6.1016ZM23.4735 25.8657C25.3209 26.17 26.9728 27.2205 27.9798 28.7492C28.4145 29.3939 28.458 29.5244 28.2913 29.6548C27.7045 30.0822 22.7055 32.9584 21.1841 33.7409C19.2569 34.7262 18.1847 35.0015 16.7574 34.8783C15.5403 34.7769 14.1855 34.1683 10.7224 32.176C9.07786 31.2341 6.8102 29.8938 6.39 29.6185C6.26684 29.5316 6.43347 29.1838 6.90439 28.539C7.94041 27.1335 9.46908 26.1845 11.1789 25.8729C11.9613 25.728 22.6113 25.728 23.4735 25.8657Z",
    fill: "url(#paint0_linear_402_1494)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_1494",
    x1: 17.3462,
    y1: 37.5,
    x2: 17.3462,
    y2: 0.500046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4394F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C0FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon41);
export default __webpack_public_path__ + "static/media/footer_icon_4_1.7ae6240a3d154452b01365a34692709f.svg";
export { ForwardRef as ReactComponent };